import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      border: `1px solid ${theme.border}`,
      borderRadius: constants.radius.view,
      padding: `${spacing.m}px ${constants.divPadding}px`,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    title: {
      fontWeight: 500,
      marginBottom: spacing.xs,
    },
    subtitle: {
      fontWeight: 400,
    },
  };

  return styles;
};
